export const headCells = [
    {id: 'id', label: 'LP'},
    {id: 'user', label: 'Nazwa szkolenia'},
    {id: 'title', label: 'Termin wykonania'},
    {id: 'content', label: 'Data ważności'},
    {id: 'isRead', label: 'Status'},
    {id: 'actions', label: 'Działania'}
]